import GameState from "slotworks/model/game-state";
import Gamestate from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class RevolverLateFreespinCheck extends Decision {
    public evaluate() {
        let result = Exit.False;

        const isRecovered = Gamestate.getCurrentGame().isRecovered;

        if (isRecovered) {
            const dummyRecord = GameState.getCurrentGame().getFirstRecord();
            if (dummyRecord instanceof FreespinRecord && !dummyRecord.beenPaid) {
                result = Exit.True;
            }
        }

        return result;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/states/revolver-late-freespin-check.ts